import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { TpCalendarModule } from 'app/components/tp-calendar/tp-calendar.module';
import { TpDropdownModule } from 'app/components/tp-dropdown/tp-dropdown.module';
import { TpTextBoxModule } from 'app/components/tp-text-box/tp-text-box.module';
import { TpTextAreaModule } from 'app/components/tp-text-area/tp-text-area.module';
import { TpToggleModule } from 'app/components/tp-toggle/tp-toggle.module';
import { CreateEditTaskComponent } from './create-edit-task.component';

@NgModule({
    declarations: [CreateEditTaskComponent],
    imports: [
        CommonModule,
        TranslateModule,
        FormsModule,
        ReactiveFormsModule,

        TpCalendarModule,
        TpDropdownModule,
        TpTextBoxModule,
        TpTextAreaModule,
        TpToggleModule,
    ],
    exports: [CreateEditTaskComponent],
})
export class CreateEditTaskModule {
}
